import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const PolicyPage = lazy(() => import('../pages/policy/page'));
const PolicyWarrantyPage = lazy(() => import('../pages/policy-warranty/page'));
const PolicyInstallmentPage = lazy(() => import('../pages/policy-installment/page'));
const PolicyPaymentPage = lazy(() => import('../pages/policy-payment/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/san-pham/:category/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/chinh-sach',
    element: <PolicyPage />,
  },
  {
    path: '/chinh-sach/bao-hanh',
    element: <PolicyWarrantyPage />,
  },
  {
    path: '/chinh-sach/tra-gop',
    element: <PolicyInstallmentPage />,
  },
  {
    path: '/chinh-sach/thanh-toan',
    element: <PolicyPaymentPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
